(function () {
  function onReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
      return;
    }

    callback();
  }

  function getStoredValue(key) {
    try {
      return window.localStorage.getItem(key) || getCookieValue(key);
    } catch (error) {
      return getCookieValue(key);
    }
  }

  function setStoredValue(key, value) {
    try {
      window.localStorage.setItem(key, value);
    } catch (error) {
      // Cookies are the fallback when localStorage is unavailable.
    }

    setCookieValue(key, value);
  }

  function getCookieValue(key) {
    var cookiePrefix = key + '=';
    var cookies = document.cookie ? document.cookie.split(';') : [];

    for (var index = 0; index < cookies.length; index += 1) {
      var cookie = cookies[index].trim();

      if (cookie.indexOf(cookiePrefix) === 0) {
        return decodeURIComponent(cookie.substring(cookiePrefix.length));
      }
    }

    return null;
  }

  function setCookieValue(key, value) {
    var oneYear = 365 * 24 * 60 * 60;
    document.cookie = key + '=' + encodeURIComponent(value) + '; max-age=' + oneYear + '; path=/; SameSite=Lax';
  }

  onReady(function () {
    var popup = document.querySelector('[data-bda-email-popup]');

    if (!popup) {
      return;
    }

    var closeButtons = popup.querySelectorAll('[data-bda-email-popup-close]');
    var emailForm = popup.querySelector('#BdaEmailPopupForm');
    var emailInput = popup.querySelector('#BdaEmailPopupEmail');
    var successMessage = popup.querySelector('[data-bda-email-success]');
    var errorMessage = popup.querySelector('[data-bda-email-errors]');
    var dismissedKey = 'bda_email_popup_dismissed_until';
    var signedUpKey = 'bda_email_popup_signed_up';
    var visibleClass = 'is-visible';
    var delay = 1400;
    var oneYearMs = 365 * 24 * 60 * 60 * 1000;

    function openPopup() {
      popup.hidden = false;
      window.requestAnimationFrame(function () {
        popup.classList.add(visibleClass);
        document.body.classList.add('bda-email-popup-open');
      });

      window.setTimeout(function () {
        if (successMessage) {
          successMessage.focus();
          return;
        }

        if (emailInput) {
          emailInput.focus();
        }
      }, 220);
    }

    function closePopup() {
      var dismissUntil = Date.now() + 7 * 24 * 60 * 60 * 1000;

      popup.classList.remove(visibleClass);
      document.body.classList.remove('bda-email-popup-open');
      setStoredValue(dismissedKey, String(dismissUntil));

      window.setTimeout(function () {
        popup.hidden = true;
      }, 200);
    }

    function markSignedUp() {
      setStoredValue(signedUpKey, 'true');
      setStoredValue(dismissedKey, String(Date.now() + oneYearMs));
    }

    function cleanSignupReturnUrl() {
      var url = new URL(window.location.href);
      var hashLooksLikeSignupReturn = url.hash === '#bda-email-signup' || url.hash === '#contact_form' || url.hash === '#BdaEmailPopupForm';
      var queryLooksLikeSignupReturn =
        url.searchParams.get('customer_posted') === 'true' ||
        url.searchParams.get('contact_posted') === 'true' ||
        url.searchParams.get('form_type') === 'customer';

      if (!hashLooksLikeSignupReturn && !queryLooksLikeSignupReturn) {
        return;
      }

      if (queryLooksLikeSignupReturn) {
        url.searchParams.delete('customer_posted');
        url.searchParams.delete('contact_posted');
        url.searchParams.delete('form_type');
      }

      if (hashLooksLikeSignupReturn) {
        url.hash = '';
      }

      if (window.history && window.history.replaceState) {
        window.history.replaceState(null, document.title, url.pathname + url.search);
      }
    }

    function isSignupReturnUrl() {
      var url = new URL(window.location.href);

      return (
        url.hash === '#bda-email-signup' ||
        url.hash === '#contact_form' ||
        url.hash === '#BdaEmailPopupForm' ||
        url.searchParams.get('customer_posted') === 'true' ||
        url.searchParams.get('contact_posted') === 'true' ||
        url.searchParams.get('form_type') === 'customer'
      );
    }

    closeButtons.forEach(function (button) {
      button.addEventListener('click', closePopup);
    });

    if (emailForm) {
      emailForm.addEventListener('submit', function () {
        markSignedUp();
      });
    }

    document.addEventListener(
      'submit',
      function (event) {
        var form = event.target;

        if (!form || !form.querySelector || !form.querySelector('input[name="contact[email]"]')) {
          return;
        }

        markSignedUp();
      },
      true
    );

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !popup.hidden) {
        closePopup();
      }
    });

    if (successMessage) {
      markSignedUp();
      cleanSignupReturnUrl();
      return;
    }

    if (errorMessage) {
      window.setTimeout(openPopup, 250);
      return;
    }

    if (getStoredValue(signedUpKey) === 'true') {
      cleanSignupReturnUrl();
      return;
    }

    if (isSignupReturnUrl()) {
      markSignedUp();
      cleanSignupReturnUrl();
      return;
    }

    var dismissedUntil = Number(getStoredValue(dismissedKey) || 0);

    if (dismissedUntil > Date.now()) {
      return;
    }

    window.setTimeout(openPopup, delay);
  });
})();
